<div
    class="notifications-container absolute left-0 top-0 mt-[var(--ion-safe-area-top)] w-full pb-4"
    *ngIf="notifications?.length">
    <ng-container *ngFor="let notification of notifications">
        <div
            class="relative mx-4 mt-4 flex flex-row items-center justify-center gap-4 rounded-2xl bg-white px-4 py-6 dark:border-2 dark:border-solid dark:border-contrast-yellow"
            [attr.aria-label]="notification?.type + ' ' + notification?.message">
            <div class="flex min-w-0 flex-1 items-center">
                <ng-container *ngTemplateOutlet="popUpContent; context: { $implicit: notification }"></ng-container>
            </div>
            <div class="flex shrink-0 items-center justify-end">
                <button
                    class="text-grey-zambezy dark:filter-yellow"
                    [attr.aria-label]="'CLOSE_NOTIFICATION' | translate"
                    (click)="closeNotification(notification)"
                    style="outline: none">
                    <span class="icon icon-input-delete"></span>
                </button>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #popUpContent let-notification>
    <ion-icon
        class="success-icon flex h-6 items-center pr-2 dark:filter-yellow"
        *ngIf="notification.type !== AlertType.Error; else errorIcon"
        aria-hidden="true"
        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/result/info-icon.svg"></ion-icon>
    <ng-template #errorIcon>
        <ion-icon
            class="error-icon flex h-8 items-center pr-2 dark:filter-yellow"
            aria-hidden="true"
            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/result/alert-icon.svg"></ion-icon>
    </ng-template>
    <span
        class="min-w-0 max-w-full flex-1 items-center whitespace-normal break-words text-base font-normal dark:filter-yellow"
        [ngClass]="{
            'var-app-light:text-primary vl-app-light:text-primary text-secondary':
                notification.type === AlertType.Success || notification.type === AlertType.Info,
            'text-red': notification.type === AlertType.Error
        }"
        ridangoAutofocus
        tabindex="-1"
        >{{ notification.message }}</span
    >
</ng-template>
